import { useTranslation } from "@msuite/ui/localization";
import { formatNumber, type NumberFormatVariant } from "@msuite/utils/numbers";

/** Props Interface */
interface CalculationFormItemPositionFieldsResultProps {
	value: number;
	variant: NumberFormatVariant;
}

export function CalculationFormItemPositionFieldsResult({
	value,
	variant,
}: CalculationFormItemPositionFieldsResultProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="flex flex-col gap-2 w-full">
			<p className="label">{t("calculations.result")}</p>
			<div className="input border-dashed h-9 flex items-center">
				<p>{formatNumber(value, variant)}</p>
			</div>
		</div>
	);
}
